const fromdataedit = [
  {
    inputdata: "",
    title: "用户名",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
    disabled: true,
  },
  {
    inputdata: "",
    title: "真实姓名",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
  },
  {
    inputdata: "",
    title: "岗位",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
  },
  {
    inputdata: "",
    title: "性别",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "radio",
    width: "210px",
    radiotitle1: "男",
    radiotitle2: "女",
    lablewith: "80px",
    radio: "",
  },
  {
    inputdata: "",
    title: "出生日期",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "datess",
    width: "220px",
  },
  {
    inputdata: "",
    title: "身份证号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
    lablewith: "110px",
  },
  {
    inputdata: "",
    title: "家庭电话",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
  },
  {
    inputdata: "",
    title: "手机号码",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
  },
  {
    inputdata: "",
    title: "电子邮箱",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
  },
  {
    inputdata: "",
    title: "地址",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "524px",
  },
  {
    inputdata: "",
    title: "是否操作员",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "text",
    inputtype: "radio",
    width: "210px",
    radiotitle1: "是",
    radiotitle2: "否",
    lablewith: "80px",
    radio: "",
  },
  {
    inputdata: "",
    title: "备注",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "520px",
  },
  // {
  //   inputdata: "",
  //   title: "所属区域",
  //   fontSize: "14px",
  //   color: "#333333",
  //   placeholder: "全部",
  //   types: "",
  //   inputtype: "cascaders",
  //   width: "230px",
  //   multiple: true,
  //   options: [
  //   ],
  // },
];
export default fromdataedit;
